/**
 * Script que se encarga de la seguridad, requiere de la librería pidCrypt, para funcionar correctamente.
 */

declare var pidCrypt: any;
declare var pidCryptUtil: any;

export function securityContext() {
  let myContext: any = {};
  let user: any;
  let config: any;
  let privKey = "MIIEowIBAAKCAQEA0cuapB0AQsC4Hly7SD9XkS6XlUMXHe7pBhYDA0YSOKG4S/+3LMBH2jUibknLYaMAxrO/tCdjL2YHVZ6VCfrHewVvZrZbr6DbBNFs5kOiR5UFocdYYuPl1eaXjtEn+mJK5A8yaMr7kK1Jbl4iyAvxDBaNHQChXpT9FXmPe/YPOMiIhoKnVoge99Y0yTPEEaTVv0NJWElIWOqd1r67cNIsNhRGwaiCYE8IZIZQYfkeHAIDY+ll222kPYXU5pDIbXAw47KRN5NtSyyDLiET31uJOiPp8RrK+rvvAwlQz0b58LvtDtmTZV4tbGM+aqRHkcwCszddFcG2+fr9zvj04CSRawIDAQABAoIBACFtOWRwonwATNW5"
                + "nLV0MjWVoN1NZT+Fs2ce1rgM0BZp3f1t7veYY1pnIOdFprwVxqfiN+cyZ2FD9mMz8zc119bIFOneoFkpXfw0ig9eM1sIaW9PXcvT1+ju5rMArEf+pUQVD8kWnmJ82bhWE2CgVnXAmhdG5G83eeOUDMKJf/9h2gX537+t9CkwiZ5HG4lZPqWauswGmTMhHiT+ZKLzVYOXpD+I+ORTqTicH5BpMH3GDabtOmJ929/d7MgG0U3OMxhVSggdWs9YWugtSj179N6gwu3ciXQY3o27Vkb3tEimB4vK2Ss+3J2TvhxuoG+R9vk16SVv1vKwOTlJGF5v1YECgYEA/fb5WZgj4jla4lEjlPhSboRSpWjFQjbtgyOurpLQDQjKcdSpj8ll"
                + "//udqRXgT6vC+kbXLYnEdFC5opMFz6tz61xd/4zU00T0fcHrz8ECyqjFyEjwl4Vu2nfI0+H2bXNjOC+hOOvN6cBSxTweipO17ywVWbSDIFkzL/8lvsUJLGECgYEA03oDc3X6O31/B2E+xQempEFUXPd5TgV+LSIPRlmFw2n2blIFwLD7bmQrL8qVOrprYBLZzNiX0hVBLD9Z6AW2OxJUKvU9hlhR9A1TKnSXJ4hazt/UgjBzgYduFpaTfzFvpiqfchs5SJ0Zv4oY9lsj/P42NLkJuL3tHrpXQ9i2MUsCgYACaA2y0KM+aIa48EXjCntVesGBub1sxDJ59KOaGeAIz5WDgJ1etGzYAR1cVc27U4hUcMlnMBABfiZUKQp8DkbZ"
                + "6xUk78OwgM3ER0shu9V38CN3o2FMPkJvpYTspQ59uQMurBzd+jYISf8+yTQM4htuOb+2CuTXMKEwij1kUl+k4QKBgQC0F61Gr4rJDMeX/k2ZNznHmccBYNLSCcV5JA9EBsruLpfpPTqe7VlBmlZY3bmWCNmWOJd4Zl9sTiNxTgX/nJWi2qoI505c0WwBXTOc7SsoRGuoz17G/AHxpeavn82+PNhq9tNQNjTjTL53qmA1tEoCkm6RGZ9Yz41WZLQaGDyX3wKBgGm43VqGvpf1ns3xFid15NlDZjHJ46YMnSz11Bw7vI6wWT1f9loQ30qTMEAK3VbJSCEzF9sU6SxlJZCbThLq8T68JSu6Bm8Frlrl1Eq1Hmf851bvuAB5LHvJ"
                + "5M0bJuakh29dfsFvx0jYqUwf57r4OJq4iQaC+MMHSE2tKLXrm0x2";
  let pubKey = "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAzWETgoOiqSu/N7AFL0CBZdutei1Jeda5t0ezLYpfb+y6hXA4VZgQCTPyc7dPumcB3c8sag0wVY9T9Wkk4NvP5LH0DjNGzKmGlByRdjn9mamfzBSwPnX+rJfpT8K52IsSZZbxCF0u3WOWMpY7UaO66zV3UPefvlGmNrIwVElyH1Zwv8+tyb8LkdGjZYYUN6+hkjrGlDrq4ytZ2Ok9LnPSDFh229Yl59Nny6TM8teC0wgSUjC5L3Ik9Sis9EwzXNj9BZgIDPkfFXxhinLQG6GdwE2SlAat2k8PkEocSobthNf0Jn90ubsKgPcCtywEcGszn3muZ8O2wFrhcJpKxW2QIQIDAQAB"
  let pem = pidCryptUtil.decodeBase64(pubKey);
  let pem2 = pidCryptUtil.decodeBase64(privKey);

  myContext.setUser = function(aUser: any) {
    user = aUser;
  }
  
  myContext.getUser = function(){
    return user;
  }
  
  myContext.setConfig = function(aConfig: any) {
    config = aConfig;
  }
  
  myContext.getConfig = function() {
    return config;
  }
  
  myContext.sha256 = function(msg: any)  {
    return pidCrypt.SHA256(msg);
  }
  
  myContext.splitFrame= function(frame: any, chunkLength:any){
    let largo = frame.length;
    let inicio = 0;
    let result = [];
    do {
      result.push(frame.substr(inicio, chunkLength));
      inicio += chunkLength;
    } while(inicio < largo);
    return result;
  }
  
  myContext.encrypt = function(clearText: any) {
    let rsa = new pidCrypt.RSA();
    let asn = pidCrypt.ASN1.decode(pidCryptUtil.toByteArray(pem));
    let tree = asn.toHexTree();
    rsa.setPublicKeyFromASN(tree);
    let aux = myContext.splitFrame(clearText, 160);
    let temp = [];
    for (let i in aux) {
      temp.push(rsa.encrypt(aux[i]));
    }
    return temp.join("");
  }
  
  myContext.decrypt = function(cipherText: any) {
    let rsa = new pidCrypt.RSA();
    let asn = pidCrypt.ASN1.decode(pidCryptUtil.toByteArray(pem2));
    let tree = asn.toHexTree();
    rsa.setPrivateKeyFromASN(tree);
    let aux = myContext.splitFrame(cipherText, 512);
    let temp = [];
    for (let i in aux) {
      temp.push(rsa.decrypt(aux[i]));
    }
    return temp.join("");
  }
  
  return myContext;
};

